/* 机构管理员系统数据平台 */
import service from '@/api/service/service';
import qs from "qs";

/* 获取机构管理员等级被训班统计 会员协会培训班统计 */
export function getClassStatisticalOrgan(params) {
  return service({
    url: '/api/statistical/class_statistical_organ.json',
    method: 'GET',
    params
  })
}

/* 获取机构管理员教案统计信息 */
export function getClassPlanOrgan(params) {
  return service({
    url: '/api/statistical/plan_statistical_organ.json',
    method: 'GET',
    params
  })
}

/* 教练员监控 讲师监控 培训班监控 成绩监控 行为监控 */
export function getLogStatisticalOrgan(params) {
  return service({
    url: '/api/statistical/class_log_statistical_organ.json',
    method: 'GET',
    params
  })
}

/* 教练员数据分析 教练员成绩分析 用户登录数量汇总 */
export function getCoachStatisticalOrgan(params) {
  return service({
    url: '/api/statistical/user_statistical_organ.json',
    method: 'GET',
    params
  })
}



